/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import React from "react";

export default function PlansSection({
  loading,
  plans,
  selectedPlan,
  setSelectedPlan,
  isArabic,
  COLORS,
  isMobile,
}) {
  if (loading) {
    return (
      <p className="text-center" style={{ color: COLORS.textLight }}>
        {isArabic ? "جارِ تحميل الباقات..." : "Loading plans..."}
      </p>
    );
  }

  return (
    <div style={{ marginBottom: "30px" }}>
      <h5
        className="fw-bold mb-4 text-center"
        style={{
          color: COLORS.gold,
          fontSize: isMobile ? "1.1rem" : "1.3rem",
          fontFamily: "'Cairo', sans-serif",
        }}
      >
        {isArabic ? "اختر الخطة" : "Select Plan"}
      </h5>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr" : "repeat(2, 1fr)",
          gap: "20px",
          marginBottom: "30px",
        }}
      >
        {plans.map((p) => (
          <div
            key={p.planId}
            onClick={() => setSelectedPlan(p.planId)}
            style={{
              background:
              Number(selectedPlan) === Number(p.planId)
              ? "rgba(255,255,255,0.12)"
                  : "rgba(255,255,255,0.05)",
              borderRadius: 15,
              padding: "25px 20px",
              border:
              Number(selectedPlan) === Number(p.planId)
              ? `2px solid ${COLORS.gold}`
                  : "1px solid rgba(255,255,255,0.15)",
              color: COLORS.textLight,
              cursor: "pointer",
              transition: "all 0.3s ease",
              display: "flex",
              flexDirection: "column",
              height: "100%",
            }}
            onMouseEnter={(e) => {
              if (Number(selectedPlan) !==Number(p.planId)) {
                e.currentTarget.style.background = "rgba(255,255,255,0.08)";
                e.currentTarget.style.borderColor = COLORS.gold;
                e.currentTarget.style.transform = "translateY(-2px)";
              }
            }}
            onMouseLeave={(e) => {
              if (Number(selectedPlan) !==Number(p.planId)) {
                e.currentTarget.style.background = "rgba(255,255,255,0.05)";
                e.currentTarget.style.borderColor = "rgba(255,255,255,0.15)";
                e.currentTarget.style.transform = "translateY(0)";
              }
            }}
          >
            {/* Plan Title */}
            <h5
              style={{
                fontWeight: "700",
                color: COLORS.gold,
                fontSize: isMobile ? "1.1rem" : "1.3rem",
                marginBottom: "12px",
                textAlign: "center",
                fontFamily: "'Cairo', sans-serif",
              }}
            >
              {p.title}
            </h5>

            {/* Plan Description */}
            <p
              style={{
                color: COLORS.textLight,
                opacity: 0.9,
                fontSize: isMobile ? "0.85rem" : "0.9rem",
                marginBottom: "15px",
                textAlign: "center",
                lineHeight: "1.6",
                flexGrow: 0,
              }}
            >
              {p.desc || (isArabic ? "بدون وصف" : "No description")}
            </p>

            {/* Price */}
            <div
              style={{
                textAlign: "center",
                marginBottom: "20px",
                padding: "12px",
                background: "rgba(242,180,65,0.1)",
                borderRadius: "10px",
                border: `1px solid ${COLORS.gold}`,
              }}
            >
              <h4
                style={{
                  fontWeight: "800",
                  color: COLORS.gold,
                  fontSize: isMobile ? "1.2rem" : "1.4rem",
                  margin: 0,
                  fontFamily: "'Cairo', sans-serif",
                }}
              >
                {p.price} {isArabic ? "د.ع" : "IQD"}
              </h4>

              <span>
                {p.price === 0
                  ? isArabic
                    ? "/ أسبوع"
                    : "/ week"
                  : isArabic
                  ? "/ شهر"
                  : "/ month"}
              </span>
            </div>

            {/* Features List */}
            {p.notes.length > 0 && (
              <div
                style={{
                  background: "rgba(255,255,255,0.05)",
                  borderRadius: "10px",
                  padding: "15px",
                  marginTop: "auto",
                  flexGrow: 1,
                }}
              >
                <h6
                  style={{
                    color: COLORS.gold,
                    fontSize: isMobile ? "0.85rem" : "0.9rem",
                    fontWeight: "600",
                    marginBottom: "12px",
                    textAlign: "center",
                    fontFamily: "'Cairo', sans-serif",
                  }}
                >
                  {isArabic ? "المميزات" : "Features"}
                </h6>
                <ul
                  className="list-unstyled"
                  style={{
                    color: COLORS.textLight,
                    fontSize: isMobile ? "0.8rem" : "0.85rem",
                    lineHeight: "1.8",
                    margin: 0,
                    padding: 0,
                  }}
                >
                  {p.notes.map((note, idx) => (
                    <li
                      key={idx}
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "8px",
                        marginBottom: "8px",
                        paddingRight: isArabic ? "0" : "0",
                        paddingLeft: isArabic ? "0" : "0",
                      }}
                    >
                      <span
                        style={{
                          color: COLORS.gold,
                          fontWeight: "bold",
                          fontSize: "1rem",
                          flexShrink: 0,
                          marginTop: "2px",
                        }}
                      >
                        ✓
                      </span>
                      <span style={{ flex: 1 }}>{note}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
